import { render, staticRenderFns } from "./publicPriceSetting.vue?vue&type=template&id=ff4f6dd4"
import script from "./publicPriceSetting.vue?vue&type=script&lang=js"
export * from "./publicPriceSetting.vue?vue&type=script&lang=js"
import style0 from "./publicPriceSetting.vue?vue&type=style&index=0&id=ff4f6dd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports